import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { cn } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

import backgroundImage from './../../assets/glass.svg';
import CloudSvg from './components/CloudSvg';
import TaskOverviewCard from './components/TaskOverviewCard';

const DelegationTasksIntro = ({ title, description, navigateToTask, tasks }) => {
  const [showContent, setShowContent] = useState({
    welcome: true,
    orchestartor: false,
    understanding: false
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent({
        welcome: false,
        orchestartor: true,
        understanding: false
      });
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const navigateToDelegatedTask = (view) => {
    navigateToTask(view);
    setShowContent({
      welcome: false,
      orchestartor: false,
      understanding: false
    });
  };

  const navigate = useNavigate();

  return (
    <>
      <div className="relative h-screen w-full overflow-hidden">
        <Icon
          icon="close-linear"
          className="absolute right-5 top-5 z-[999999] cursor-pointer"
          onClick={() => navigate('/portal')}
        />
        <div className="animate-svg-top absolute -bottom-80 -right-28 z-[9999] opacity-50">
          <CloudSvg />
        </div>
        <div className="animate-svg-bottom absolute -left-28 -top-96 z-[9999] rotate-180 opacity-50">
          <CloudSvg />
        </div>
        <div className="absolute z-[9999] h-full w-full backdrop-blur-[30px]"></div>
        <div
          className="absolute bottom-0 left-0 top-0 h-full w-full"
          style={{
            background:
              'linear-gradient(223.714deg, rgba(239,239,239,0.6) 0%, rgba(255,255,255,0.08) 100%)'
          }}></div>
      </div>
      <div
        className={cn(
          'animate-zoomIn-image url(${backgroundImage}) fixed left-0 top-0 z-[999] flex h-screen w-screen flex-col items-center justify-center bg-opacity-50 bg-cover bg-center text-center text-white transition-all duration-700'
        )}
        style={{ background: `url(${backgroundImage})` }}></div>
      <div
        className={cn(
          'animate-background fixed left-0 top-0 z-[999] flex h-screen w-screen flex-col items-center justify-center bg-cover bg-center text-center text-white transition-all duration-700',
          showContent.welcome ? 'bg-opacity-0' : 'bg-opacity-100'
        )}
        style={{ background: '#B0EAFF' }}></div>
      {showContent.welcome && (
        <div
          className={`absolute bottom-0 left-0 right-0 top-0 z-[99999] flex flex-col items-center justify-center gap-2 text-center transition-all duration-500 ${
            showContent.welcome ? 'opacity-100' : 'opacity-0'
          }`}>
          <p className="text-4xl text-primary-300">Welcome to</p>
          <h1 className="mb-6 text-7xl font-600 text-primary-900">{title}</h1>
          <p className="text-2xl text-primary-900">{description}</p>
        </div>
      )}
      <div
        className={`absolute bottom-0 left-0 right-0 top-0 z-[99999] flex flex-col items-center justify-center gap-2 text-center transition-transform duration-500 ${
          showContent.orchestartor ? 'opacity-100' : 'opacity-0'
        }`}>
        <div className="mb-10 mt-16 flex h-full w-full flex-col px-20 py-10">
          <div className="mb-6 flex flex-shrink-0 flex-col gap-3">
            <div className="text-3xl font-semibold text-primary-900">Delegated Tasks</div>
            <div className="text-2xl font-semibold text-primary-800">
              Review tasks delegated to you
            </div>
          </div>
          <div className="flex min-h-0 w-full flex-1 items-center justify-center">
            <div className="flex h-full w-fit flex-col items-center gap-2 overflow-y-auto overflow-x-hidden">
              {tasks?.map((task) => (
                <TaskOverviewCard
                  key={task.id}
                  {...{ task }}
                  navigateToTask={navigateToDelegatedTask}
                />
              ))}
            </div>
          </div>
          <div className="mt-6 flex flex-shrink-0 items-center justify-center">
            <Button
              highlighted
              size="large"
              className="border-rotate w-[300px] !text-lg font-light"
              text="Review All Tasks"
              onClick={() =>
                navigateToDelegatedTask({
                  stepCode: tasks?.[0]?.step_code,
                  substepCode: tasks?.[0]?.substep_code
                })
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DelegationTasksIntro;
